import { IndexedParticipation, ParticipationStatus } from '@app/api';
import { useParticipationTableContext } from './ParticipationTableContext';
import { Chip, FormatSimpleIcon } from '@app/core';
import React from 'react';
import { createUseStyles } from 'react-jss';
import { Theme } from '@app/theme';
import { useDateTimeFormatter } from 'pages/Dashboard/Sessions/Details/hooks/useDateTimeFormatter';

const useStyles = createUseStyles((theme: Theme) => ({
  formatIcon: {
    marginRight: theme.marginBase,
  },
}));

export const MeetingDateCell = ({
  participation,
}: {
  participation: IndexedParticipation;
}) => {
  const { session } = useParticipationTableContext();
  const { dateTimeShortFormatter } = useDateTimeFormatter();
  const classes = useStyles();

  return (
    <td key="meetingDate">
      {participation.meetingDate && (
        <Chip
          color={
            participation.status !== ParticipationStatus.BOOKED
              ? 'inkSecondary'
              : 'green'
          }
        >
          {session.format && (
            <FormatSimpleIcon
              format={session.format}
              className={classes.formatIcon}
            />
          )}
          {dateTimeShortFormatter
            .format(new Date(participation.meetingDate))
            .replace(' ', ' - ')}
        </Chip>
      )}
    </td>
  );
};
